import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import { useTheme } from '@websky/core/src/theme';
import { LockIconRu } from '../../../../../core/src/Icons';

const DescriptionRender: EngineRenderers['DescriptionRenderers'] = props => {
	const { DescriptionBlock: css } = useTheme('FareLock');

	return <div className={css.icon}>{LockIconRu}</div>;
};
export default DescriptionRender;
